import { useEffect, useMemo, useState } from 'react'
import { DataGrid } from '@material-ui/data-grid'
import { postIndustry } from '../data'
import { Button, Container, FormControl, InputLabel, LinearProgress, NativeSelect } from '@material-ui/core'
import { Helmet } from 'react-helmet-async'

function HullPrices({ build_type }) {
    const [data, setData] = useState([])
    const [error, setError] = useState(null)
    const [loaded, setLoaded] = useState(false)
    const [config, setConfig] = useState({
        rsystem: '1DQ1-A',
        fsystem: '1DQ1-A',
    })
    const fetchData = () => {
        Promise.all([postIndustry([build_type], { config: config })])
            .then((results) => {
                setData(results[0].data)
                setLoaded(true)
                setError(null)
            })
            .catch((error) => {
                setError(error)
            })
    }

    const columns = useMemo(
        () => [
            {
                field: 'id',
                headerName: '',
                width: 50,
                renderCell: (params) =>
                    params.row.invalid ? null : (
                        <img
                            src={`https://images.evetech.net/types/${params.value}/icon?size=32`}
                            alt={params.row.itemName}
                            width={25}
                            height={25}
                        />
                    ),
            },
            {
                field: 'name',
                headerName: 'Item',
                width: 150,
            },
            {
                field: 'group',
                headerName: 'Group',
                width: 150,
            },
            {
                field: 'cost',
                headerName: 'Cost',
                width: 150,
                valueFormatter: (params) => params.value.toLocaleString(),
            },
            {
                field: 'local_sell',
                headerName: 'UALX sell',
                width: 150,
                valueFormatter: (params) => params.value.toLocaleString(),
            },
            {
                field: 'local_volume',
                headerName: 'Weekly',
                width: 150,
                valueFormatter: (params) => params.value.toLocaleString(),
            },
            {
                field: 'local_markup',
                headerName: 'Markup',
                width: 150,
                renderCell: (params) =>
                    params.value < 0 ? (
                        <span style={{ color: 'red' }}>{params.value.toLocaleString()}</span>
                    ) : (
                        <span>{params.value.toLocaleString()}</span>
                    ),
            },
            {
                field: 'local_margin',
                headerName: 'Margin',
                width: 150,
                renderCell: (params) =>
                    params.value < 0 ? (
                        <span style={{ color: 'red' }}>{params.value.toLocaleString()}%</span>
                    ) : (
                        <span>{params.value.toLocaleString()}%</span>
                    ),
            },
            {
                field: 'jita_sell',
                headerName: 'Jita sell',
                width: 150,
                valueFormatter: (params) => params.value.toLocaleString(),
            },
            {
                field: 'jita_markup',
                headerName: 'Markup',
                width: 150,
                renderCell: (params) =>
                    params.value < 0 ? (
                        <span style={{ color: 'red' }}>{params.value.toLocaleString()}</span>
                    ) : (
                        <span>{params.value.toLocaleString()}</span>
                    ),
            },
            {
                field: 'jita_margin',
                headerName: 'Margin',
                width: 150,
                renderCell: (params) =>
                    params.value < 0 ? (
                        <span style={{ color: 'red' }}>{params.value.toLocaleString()}%</span>
                    ) : (
                        <span>{params.value.toLocaleString()}%</span>
                    ),
            },
            {
                field: 'jita_volume',
                headerName: 'Weekly',
                width: 150,
                valueFormatter: (params) => params.value.toLocaleString(),
            },
        ],
        []
    )

    useEffect(() => {
        fetchData()
    }, [])

    if (error) {
        return (
            <Container>
                <h3>Error</h3>
                <p>{error.message}</p>
            </Container>
        )
    }

    if (!loaded) return <LinearProgress />

    return (
        <div style={{ width: '100%' }}>
            <Helmet>
                <title>T2 hulls prices</title>
            </Helmet>
            <FormControl>
                <InputLabel>Reacting System</InputLabel>
                <NativeSelect
                    inputProps={{
                        name: 'rsystem',
                    }}
                    onChange={(e: HashChangeEvent<HTMLSelectElement>) =>
                        setConfig((x) => ({ ...x, rsystem: e.target.value }))
                    }
                >
                    <option value={'Jita'}>Jita</option>
                    <option value={'R959-U'}>R959-U</option>
                    <option value={'Q4C-S5'}>Q4C-S5</option>
                </NativeSelect>
            </FormControl>
            <FormControl>
                <InputLabel>Manufacturing System</InputLabel>
              <NativeSelect
                inputProps={{
                  name: 'fsystem',
                }}
                onChange={(e: HashChangeEvent<HTMLSelectElement>) =>
                  setConfig((x) => ({ ...x, fsystem: e.target.value }))
                }
              >
                  <option value={'PE1-R1'}>PE1-R1</option>
                  <option value={'GPLB-C'}>GPLB-C</option>
                  <option value={'C-J6MT'}>C-J6MT</option>
              </NativeSelect>
            </FormControl>
          <FormControl>
            <Button variant="contained" onClick={fetchData}>
              Apply
            </Button>
          </FormControl>
          <ul style={{ textAlign: 'left' }}>
            <li>Manufacturing system: {config.fsystem}</li>
            <li>Reaction system: {config.rsystem}</li>
          </ul>
          <ul style={{ textAlign: 'center' }}>
            Invention cost for hulls is a bit inflated. Based on one job with parity decryptor.
            <br />
            Module invention without decryptor, so rigs invention cost might be wrong.
          </ul>
          <DataGrid columns={columns} rows={data} rowHeight={25} autoHeight />
        </div>
    )
}

export default HullPrices
